import { render, staticRenderFns } from "./DialogAddCustomer.vue?vue&type=template&id=88a9498e"
import script from "./DialogAddCustomer.vue?vue&type=script&lang=js"
export * from "./DialogAddCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports